export const PAYMENT_SUBSCIPTION_LOADED_SUCCESS =
  'PAYMENT_SUBSCIPTION_LOADED_SUCCESS'
export const PAYMENT_SUBSCIPTION_LOADED_FAIL = 'PAYMENT_SUBSCIPTION_LOADED_FAIL'
export const PAYMENT_SUBSCIPTION_UPDATED_SUCCESS =
  'PAYMENT_SUBSCIPTION_UPDATED_SUCCESS'
export const PAYMENT_SUBSCIPTION_UPDATED_FAIL =
  'PAYMENT_SUBSCIPTION_UPDATED_FAIL'
export const PAYMENT_SUBSCIPTION_CREATED_SUCCESS =
  'PAYMENT_SUBSCIPTION_CREATED_SUCCESS'
export const PAYMENT_SUBSCIPTION_CREATED_FAIL =
  'PAYMENT_SUBSCIPTION_CREATED_FAIL'
export const PAYMENT_SUBSCIPTION_BY_ORDERID_LOADED_SUCCESS =
  'PAYMENT_SUBSCIPTION_BY_ORDERID_LOADED_SUCCESS'
export const PAYMENT_SUBSCIPTION_BY_ORDERID_LOADED_FAIL =
  'PAYMENT_SUBSCIPTION_BY_ORDERID_LOADED_FAIL'
export const PAYMENT_MANAGEMENT_DATA_LOADED_SUCCESS =
  'PAYMENT_MANAGEMENT_DATA_LOADED_SUCCESS'
export const PAYMENT_MANAGEMENT_DATA_LOADED_FAIL =
  'PAYMENT_MANAGEMENT_DATA_LOADED_FAIL'
export const PAYMENT_ISSUE_HANDLED_SUCCESS = 'PAYMENT_ISSUE_HANDLED_SUCCESS'
export const PAYMENT_ISSUE_HANDLED_FAIL = 'PAYMENT_ISSUE_HANDLED_FAIL'
